import { render, staticRenderFns } from "./_layout.vue?vue&type=template&id=86fca8aa&scoped=true&"
import script from "./_layout.vue?vue&type=script&lang=js&"
export * from "./_layout.vue?vue&type=script&lang=js&"
import style0 from "./_layout.vue?vue&type=style&index=0&id=86fca8aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fca8aa",
  null
  
)

export default component.exports